<template>
  <v-container>
    <v-dialog v-model="dialog.delete" scrollable persistent width="350">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-information</v-icon>
          Informasi
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <p class="ma-0 body-1">
            <template v-if="selectedPage === 'reset'">
              Apakah anda yakin mereset kata sandi pengguna
            </template>
            <template v-if="selectedPage !== 'reset'">
              Apakah anda yakin menghapus pengguna
            </template>
            <span class="font-weight-bold">
              {{ detail.accountName }}
            </span>
            ?
          </p>
          <v-alert
            v-if="error.message"
            text
            type="error"
            class="custom-alert my-4"
          >
            <p class="body-2 mb-0">
              {{ error.message }}
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            text
            color="red"
            elevation="0"
            :disabled="loadFormAccount"
            class="text-capitalize"
            @click="
              selectedPage !== 'reset'
                ? deleteAccountHandler(detail.accountId)
                : resetAccountHandler(detail.accountId)
            "
          >
            {{ selectedPage !== 'reset' ? 'Hapus' : 'Reset' }}
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            :disabled="loadFormAccount"
            @click="resetForm"
            class="white--text text-capitalize"
          >
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.filter" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-filter</v-icon>
          Filter list Pengguna
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="formFilter">
            <p class="subtitle-2 mb-3 text--secondary">
              Informasi pengguna
            </p>
            <v-text-field
              dense
              outlined
              clearable
              label="NRP/NIK"
              color="light-green"
              v-model="formFilter.account_code"
            />
            <p class="subtitle-2 mb-3 text--secondary">
              Lokasi pengguna
            </p>
            <v-autocomplete
              v-model="formFilter.unit"
              :loading="loadUnitOptions"
              :items="unitOptions"
              :search-input.sync="searchUnitsOptions"
              cache-items
              clearable
              dense
              outlined
              color="light-green"
              label="Wilayah"
              item-text="unitName"
              return-object
            />
            <v-autocomplete
              :cache-items="defaultArea"
              v-model="formFilter.subdistrict"
              :loading="loadSubdistricts"
              :items="subdistricts"
              :search-input.sync="searchSubdistricts"
              dense
              outlined
              clearable
              color="light-green"
              label="Pilih Kecamatan"
              item-text="subdistrictName"
              return-object
            />
            <p class="subtitle-2 mb-3 text--secondary">
              Status Pengguna
            </p>
            <v-select
              dense
              outlined
              color="light-green"
              label="Status Pengguna"
              :items="status"
              item-text="name"
              item-value="value"
              v-model="formFilter.account_is_active"
            />
          </v-form>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            class="text-capitalize grey--text text--darken-1"
            @click.stop="resetForm"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="orange lighten-1"
            elevation="0"
            @click="resetFilter"
            class="white--text text-capitalize"
          >
            Reset
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            @click="saveFilter"
            class="white--text text-capitalize"
          >
            Filter
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog.create" persistent scrollable max-width="600">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon color="white" class="mr-2">mdi-account</v-icon>
          {{ selectedPage === 'update' ? 'Ubah' : 'Tambah' }}
          Pengguna
          <v-btn class="mt-n1" icon dark top right absolute @click="resetForm">
            <v-icon color="grey">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-6">
          <ValidationObserver ref="observer">
            <v-form ref="form" :readonly="loadFormAccount">
              <p class="subtitle-2 mb-3 text--secondary">
                Informasi Pengguna
              </p>
              <ValidationProvider
                name="Nama"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  dense
                  outlined
                  label="Nama"
                  color="light-green"
                  v-model="form.account_name"
                  :error-messages="formErrors.account_name || errors"
                >
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider
                name="NRP"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  dense
                  outlined
                  label="NRP/NIK"
                  color="light-green"
                  v-model="form.account_code"
                  :error-messages="formErrors.account_code || errors"
                />
              </ValidationProvider>
              <ValidationProvider
                name="Telepon"
                rules="required|min:8|max:13"
                v-slot="{ errors }"
              >
                <v-text-field
                  dense
                  outlined
                  label="Telepon"
                  type="number"
                  color="light-green"
                  v-model="form.account_mobilephone"
                  :error-messages="formErrors.account_mobilephone || errors"
                />
              </ValidationProvider>
              <ValidationProvider
                name="Email"
                rules="email"
                v-slot="{ errors }"
              >
                <v-text-field
                  dense
                  outlined
                  label="Email"
                  color="light-green"
                  v-model="form.account_email"
                  :error-messages="formErrors.account_email || errors"
                />
              </ValidationProvider>
              <ValidationProvider
                name="Jabatan"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="form.account_position"
                  :error-messages="formErrors.account_position || errors"
                  :loading="loadPositionOptions"
                  :items="positionOptions"
                  :search-input.sync="searchPositionsOptions"
                  cache-items
                  dense
                  outlined
                  color="light-green"
                  label="Jabatan"
                  item-text="accountPosition"
                  item-value="accountPosition"
                />
              </ValidationProvider>
              <ValidationProvider
                name="Wilayah"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="form.unit"
                  :error-messages="formErrors.account_unit_id || errors"
                  :loading="loadUnitOptions"
                  :items="unitOptions"
                  :search-input.sync="searchUnitsOptions"
                  cache-items
                  dense
                  outlined
                  color="light-green"
                  label="Wilayah"
                  item-text="unitName"
                  return-object
                />
              </ValidationProvider>
              <ValidationProvider
                name="Role"
                rules="required"
                v-slot="{ errors }"
              >
                <v-autocomplete
                  v-model="form.group"
                  :error-messages="formErrors.account_group_id || errors"
                  :loading="loadGroupOptions"
                  :items="groupOptions"
                  :search-input.sync="searchGroupsOptions"
                  cache-items
                  dense
                  outlined
                  color="light-green"
                  label="Role"
                  item-text="accountGroupName"
                  return-object
                />
              </ValidationProvider>
              <template
                v-if="
                  form.account_position &&
                    (form.account_position === 'Satgas RW' ||
                      form.account_position === 'Satgas RT')
                "
              >
                <ValidationProvider
                  name="Rw"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    color="light-green"
                    label="RW"
                    v-model="form.rw"
                    :error-messages="errors"
                  />
                </ValidationProvider>
                <ValidationProvider
                  name="Rt"
                  :rules="
                    form.account_position === 'Satgas RT' ? 'required' : ''
                  "
                  v-slot="{ errors }"
                >
                  <v-text-field
                    dense
                    outlined
                    type="number"
                    color="light-green"
                    label="RT"
                    v-model="form.rt"
                    :error-messages="errors"
                  />
                </ValidationProvider>
              </template>
              <p class="subtitle-2 mb-3 text--secondary">
                Status Pengguna
              </p>
              <ValidationProvider
                name="Status"
                rules="required"
                v-slot="{ errors }"
              >
                <v-switch
                  v-model="form.is_active"
                  :error-messages="formErrors.is_active || errors"
                  :label="form.is_active ? 'Aktif' : 'Non-Aktif'"
                  dense
                  color="light-green"
                />
              </ValidationProvider>
              <div class="mb-5">
                <p class="subtitle-2 mb-2 text--secondary">Gambar Profil</p>
                <div class="dropzone-input" v-if="!form.account_avatar">
                  <vue-dropzone
                    ref="ImageVueDropzone"
                    id="dropzone"
                    :destroy-dropzone="true"
                    :use-custom-slot="true"
                    :options="dropzoneSingleImageOptions"
                    @vdropzone-success="handleUploadSingleImageSuccess"
                  >
                    <div class="dropzone-custom-content">
                      <v-icon x-large>mdi-file-image-outline</v-icon>
                      <h3 class="dropzone-custom-title mt-2">
                        Tarik dan letakkan <br />
                        gambar Anda disini!
                      </h3>
                      <div class="subtitle">atau klik disini</div>
                    </div>
                  </vue-dropzone>
                </div>
                <v-card
                  class="container-preview"
                  flat
                  elevation="2"
                  v-else
                  width="100%"
                  height="150"
                >
                  <v-avatar
                    tile
                    width="100%"
                    height="150"
                    class="grey lighten-3 cursor-pointer"
                  >
                    <v-img
                      contain
                      :src="form.account_avatar"
                      :alt="form.account_avatar"
                    />
                  </v-avatar>
                  <div class="middle">
                    <v-btn
                      color="red"
                      dark
                      small
                      fab
                      @click="removeSingleImageHandler"
                    >
                      <v-icon dark>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </div>
                </v-card>
              </div>
            </v-form>
          </ValidationObserver>
          <v-alert
            v-if="error.message"
            text
            type="error"
            class="custom-alert my-4"
          >
            <p class="body-2 mb-0">
              {{ error.message }}
            </p>
          </v-alert>
        </v-card-text>
        <v-card-actions class="pb-6 px-6">
          <v-spacer></v-spacer>
          <v-btn
            small
            color="#fff"
            elevation="0"
            :disabled="loadFormAccount"
            class="text-capitalize grey--text text--darken-1"
            @click="resetForm"
          >
            Batal
          </v-btn>
          <v-btn
            small
            light
            color="light-green"
            elevation="0"
            :disabled="loadFormAccount"
            :loading="loadFormAccount"
            @click="saveForm"
            class="white--text text-capitalize"
          >
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-title>
            <div class="text--secondary">List Pengguna</div>
          </v-card-title>
          <v-card-subtitle class="mt-3">
            <v-sheet class="d-sm-flex align-center justify-space-between">
              <v-btn
                :block="$vuetify.breakpoint.name === 'xs'"
                color="light-green"
                class="text-capitalize"
                dark
                elevation="2"
                @click.stop="dialog.create = true"
              >
                <v-icon small>mdi-plus</v-icon> Pengguna
              </v-btn>
              <v-sheet class="d-sm-flex mt-4 mt-sm-0 align-center">
                <v-text-field
                  dense
                  outlined
                  v-model="search"
                  hide-details
                  placeholder="Cari Pengguna . . ."
                  clearable
                  color="light-green"
                  prepend-inner-icon="mdi-magnify"
                  class="mb-4 mb-sm-0 mr-sm-2"
                  :full-width="$vuetify.breakpoint.name === 'xs'"
                >
                </v-text-field>
                <v-row dense class="py-0">
                  <v-col>
                    <v-btn
                      :block="$vuetify.breakpoint.name === 'xs'"
                      color="grey lighten-3"
                      class="text-capitalize grey--text text--darken-1"
                      elevation="0"
                      @click.stop="
                        dialog.filter = true;
                        formUnitOptionsName = 'filter';
                      "
                    >
                      Filter
                    </v-btn>
                  </v-col>
                  <v-col>
                    <v-btn
                      :block="$vuetify.breakpoint.name === 'xs'"
                      color="grey lighten-3"
                      class="text-capitalize grey--text text--darken-1"
                      elevation="0"
                      :loading="loadExportAccount"
                      @click="exportAccount"
                    >
                      Export
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-sheet>
            <v-container class="pa-0" v-if="filter.filtered">
              <v-row dense>
                <v-col cols="12" class="mt-2">
                  Filter By
                </v-col>
                <v-col class="py-0">
                  <v-chip-group show-arrows>
                    <v-chip
                      v-if="filter.account_code"
                      close
                      @click:close="
                        formFilter.account_code = '';
                        saveFilter();
                      "
                    >
                      NRP/NIK {{ filter.account_code }}
                    </v-chip>
                    <v-chip
                      v-if="filter.subdistrict"
                      close
                      @click:close="
                        formFilter.subdistrict = null;
                        saveFilter();
                      "
                    >
                      Kecamatan {{ filter.subdistrict.subdistrictName }}
                    </v-chip>
                    <v-chip
                      v-if="filter.unit"
                      close
                      @click:close="
                        formFilter.unit = null;
                        saveFilter();
                      "
                    >
                      Wilayah {{ filter.unit.unitName }}
                    </v-chip>
                    <v-chip
                      v-if="filter.account_is_active !== ''"
                      close
                      @click:close="
                        formFilter.account_is_active = '';
                        saveFilter();
                      "
                    >
                      Status
                      {{ filter.account_is_active ? 'Aktif' : 'Tidak Aktif' }}
                    </v-chip>
                  </v-chip-group>
                </v-col>
              </v-row>
            </v-container>
          </v-card-subtitle>
          <v-card-text>
            <v-divider class="my-2" />
            <v-skeleton-loader
              class="ma-auto"
              :loading="loadAccounts"
              transition="fade-transition"
              :tile="false"
              type="table-row"
              v-for="index in loadAccounts ? 10 : 1"
              :key="index"
            >
              <v-data-table
                v-show="accounts.length >= 1"
                :headers="headers"
                mobile-breakpoint="1"
                hide-default-footer
                :items="accounts"
                fixed-header
                min-height="250px"
                :height="
                  $vuetify.breakpoint.name !== 'xs' && filter.filtered
                    ? 'calc(100vh - 60vh)'
                    : $vuetify.breakpoint.name !== 'xs'
                    ? 'calc(100vh - 50vh)'
                    : ''
                "
              >
                <template v-slot:[`item.aksi`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="green"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="toDetail(item)"
                      >
                        <v-icon small>mdi-alert-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Detail</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="blue darken-1"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="updateAccountHandler(item)"
                      >
                        <v-icon small>mdi-square-edit-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="orange darken-1"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          detail = item;
                          dialog.delete = true;
                          selectedPage = 'reset';
                        "
                      >
                        <v-icon small>mdi-key-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>Reset Password</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        x-small
                        color="red"
                        elevation="0"
                        class="text-capitalize white--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        @click="
                          detail = item;
                          dialog.delete = true;
                        "
                      >
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.accountName`]="{ item }">
                  <v-sheet class="d-flex align-center py-3 transparent">
                    <v-avatar
                      :color="item.accountAvatar ? 'white' : 'grey lighten-2'"
                    >
                      <v-img :src="item.accountAvatar" />
                    </v-avatar>
                    <h3
                      v-text="item.accountName"
                      class="body-2 font-weight-regular ml-3"
                    />
                  </v-sheet>
                </template>
                <template v-slot:[`item.accountIsActive`]="{ item }">
                  <span
                    :class="
                      item.accountIsActive * 1 ? 'green--text' : 'red--text'
                    "
                    class="transparent"
                  >
                    {{ item.accountIsActive * 1 ? 'Aktif' : 'Non-Aktif' }}
                  </span>
                </template>
                <template v-slot:[`item.accountEmail`]="{ item }">
                  {{ item.accountEmail || '-' }}
                </template>
                <template v-slot:[`item.accountLastLogin`]="{ item }">
                  <template v-if="item.accountLastLogin">
                    {{ item.accountLastLogin | datetime }}
                  </template>
                  <template v-if="!item.accountLastLogin">
                    -
                  </template>
                </template>
              </v-data-table>
            </v-skeleton-loader>
            <div
              class="text-center text--secondary"
              v-show="!loadAccounts && accounts.length < 1"
            >
              <v-icon
                style="font-size: 60px; margin-top: 1.5em"
                color="light-green"
              >
                mdi-close-circle-outline
              </v-icon>
              <p class="headline font-weight-bold mt-2 mb-1">Data kosong</p>
              <p>Data yang Anda cari tidak ada disini</p>
            </div>
          </v-card-text>
          <v-card-actions class="pb-6 px-6">
            <v-row>
              <v-col
                v-if="
                  paginationAccounts.totalData > 0 &&
                    $vuetify.breakpoint.name !== 'xs'
                "
                cols="5"
              >
                <div class="body-2 font-weight-bold mt-4">
                  Total {{ paginationAccounts.totalData }} data
                </div>
              </v-col>
              <v-col
                v-if="paginationAccounts.totalPage > 1"
                :cols="$vuetify.breakpoint.name !== 'xs' ? '7' : '12'"
              >
                <div class="float-sm-right">
                  <v-pagination
                    v-model="page"
                    :length="paginationAccounts.totalPage"
                    :total-visible="5"
                    color="light-green"
                    @input="getAccountsHandler()"
                    circle
                  >
                  </v-pagination>
                </div>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import account from '@/mixins/account';
import group from '@/mixins/group';
import unit from '@/mixins/unit';
import position from '@/mixins/position';
import area from '@/mixins/area';
import debounce from 'lodash.debounce';
import dropzone from '@/mixins/dropzone';
export default {
  mixins: [account, group, unit, position, area, dropzone],
  data() {
    return {
      search: '',
      defaultArea: true,
      formAddressName: 'filter',
      formPositionOptionsName: 'form',
      formUnitOptionsName: 'form',
      formGroupOptionsName: 'form',
      detail: {},
      page: 1,
      filter: {
        filtered: false,
        subdistrict: null,
        unit: null,
        account_code: '',
        account_is_active: ''
      },
      formFilter: {
        subdistrict: null,
        unit: null,
        account_code: '',
        account_is_active: ''
      },
      form: {
        id: '',
        account_name: '',
        account_code: '',
        account_mobilephone: '',
        account_email: '',
        account_position: '',
        unit: '',
        group: '',
        account_avatar: '',
        is_active: true,
        rt: '',
        rw: ''
      },
      dialog: {
        create: false,
        delete: false,
        filter: false
      },
      status: [
        {
          name: 'Semua',
          value: ''
        },
        {
          name: 'Aktif',
          value: 1
        },
        {
          name: 'Tidak Aktif',
          value: 0
        }
      ],
      selectedPage: '',
      headers: [
        {
          text: 'Aksi',
          value: 'aksi',
          align: 'start',
          width: 230,
          sortable: false,
          class: 'font-weight-black body-2'
        },
        {
          text: 'Nama',
          width: 230,
          class: 'font-weight-black body-2',
          value: 'accountName'
        },
        {
          text: 'NRP/NIK',
          width: 230,
          class: 'font-weight-black body-2',
          value: 'accountCode'
        },
        {
          text: 'Jabatan',
          width: 230,
          class: 'font-weight-black body-2',
          value: 'accountPosition'
        },
        {
          text: 'Telepon',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'accountMobilephone'
        },
        {
          text: 'Email',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'accountEmail'
        },
        {
          text: 'Wilayah',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'unitName'
        },
        {
          text: 'Kecamatan',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'unitSubdistrictName'
        },
        {
          text: 'Status',
          width: 100,
          class: 'font-weight-black body-2',
          value: 'accountIsActive'
        },
        {
          text: 'Login Terakhir',
          width: 200,
          class: 'font-weight-black body-2',
          value: 'accountLastLogin'
        }
      ]
    };
  },
  watch: {
    search: {
      handler: debounce(function() {
        this.page = 1;
        this.getAccountsHandler();
      }, 500),
      immediate: true
    }
  },
  created() {
    this.getPositionOptions();
    this.getGroupOptions();
  },
  methods: {
    async getAccountsHandler() {
      const filters = [
        {
          type: 'string',
          field: 'account_name',
          value: this.search,
          comparison: '<>'
        },
        {
          type: 'string',
          field: 'account_code',
          value: this.filter.account_code,
          comparison: '<>'
        },
        // {
        //   type: 'string',
        //   field: 'account_position',
        //   value: this.filter.account_position,
        //   comparison: '<>'
        // },
        // {
        //   type: 'string',
        //   field: 'account_mobilephone',
        //   value: this.filter.account_mobilephone,
        //   comparison: '<>'
        // },
        {
          type: 'string',
          field: 'account_unit_id',
          value: this.filter.unit && this.filter.unit.unitId
        },
        {
          type: 'string',
          field: 'unit_subdistrict_id',
          value:
            (this.filter.subdistrict &&
              this.filter.subdistrict.subdistrictId !== 'all' &&
              this.filter.subdistrict.subdistrictId) ||
            ''
        },
        {
          type: 'string',
          field: 'account_is_active',
          value: this.filter.account_is_active
        }
        // {
        //   field: 'account_last_login',
        //   type: 'date',
        //   value:
        //     this.filter.end && this.filter.end.length > 0
        //       ? `${this.filter.start}::${this.filter.end}`
        //       : '',
        //   comparison: 'bet'
        // }
      ];
      const payload = {
        filters,
        page: this.page
      };
      await this.getAccounts(payload);
    },
    handleUploadSingleImageSuccess(file, response) {
      this.form.account_avatar = response.data.results.url.compressed;
    },
    removeSingleImageHandler() {
      this.form.account_avatar = '';
    },
    async saveFilter() {
      this.page = 1;
      this.filter = {
        subdistrict: this.formFilter.subdistrict,
        unit: this.formFilter.unit,
        account_code: this.formFilter.account_code,
        account_is_active: this.formFilter.account_is_active
      };
      if (
        this.formFilter.subdistrict ||
        this.formFilter.account_is_active !== '' ||
        this.formFilter.account_code ||
        this.formFilter.unit
      ) {
        this.filter.filtered = true;
      }
      this.resetForm();
      await this.getAccountsHandler();
    },
    async resetFilter() {
      this.page = 1;
      this.filter = {
        filtered: false,
        subdistrict: null,
        unit: null,
        account_code: '',
        account_is_active: ''
      };
      this.formFilter = {
        subdistrict: null,
        unit: null,
        account_code: '',
        account_is_active: ''
      };
      this.resetForm();
      await this.getAccountsHandler();
    },
    toDetail(item) {
      this.$router.push({
        name: 'user-laporan',
        params: { id: item.accountId }
      });
    },
    resetForm() {
      this.clearError();
      if (this.$refs.observer) this.$refs.observer.reset();
      this.dialog = {
        create: false,
        delete: false,
        filter: false
      };
      this.formPositionOptionsName = 'form';
      this.formUnitOptionsName = 'form';
      this.form = {
        id: '',
        account_name: '',
        account_code: '',
        account_mobilephone: '',
        account_email: '',
        account_position: '',
        unit: '',
        group: '',
        account_avatar: '',
        is_active: true
      };
      this.selectedPage = '';
      this.detail = {};
    },
    async saveForm() {
      this.clearError();
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        try {
          if (this.form.id) {
            await this.updateAccount(this.form, this.form.id);
          } else {
            await this.createAccount(this.form);
          }
          this.page = 1;
          this.resetForm();
          await this.getAccountsHandler();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }
    },
    updateAccountHandler(account) {
      this.selectedPage = 'update';
      this.form = {
        id: account.accountId,
        account_name: account.accountName,
        account_code: account.accountCode,
        account_mobilephone: account.accountMobilephone,
        account_email: account.accountEmail,
        account_position: account.accountPosition,
        unit: {
          unitId: account.accountUnitId,
          unitName: account.unitName
        },
        group: {
          accountGroupId: account.accountAccountGroupId,
          accountGroupName: account.accountGroupName
        },
        account_avatar: account.accountAvatar,
        is_active: account.accountIsActive * 1 ? true : false,
        rw: account.accountUnitName.split('/')[0],
        rt: account.accountUnitName.split('/')[1]
      };
      this.dialog.create = true;
      this.showPage = true;
    },
    async deleteAccountHandler(id) {
      this.clearError();
      try {
        await this.deleteAccount(id);
        this.page = 1;
        this.resetForm();
        await this.getAccountsHandler();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    },
    async resetAccountHandler(id) {
      this.clearError();
      try {
        await this.resetAccount(id);
        this.page = 1;
        this.resetForm();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
      }
    }
  }
};
</script>
